export default __webpack_public_path__ + "static/media/eigenheim_icons_comp.eb9132b3.svg";